import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', _vm._l(_vm.value.properties.outboundConfiguration, function (item, index) {
    return _c('core-n20-card', {
      key: `outbound_${index}`,
      staticClass: "dt-card-text-01 outbound-card pa-0",
      scopedSlots: _vm._u([{
        key: "buttons",
        fn: function () {
          return [_c('core-button', {
            attrs: {
              "color": _vm.color,
              "prepend-icon": "fa-trash-alt"
            },
            on: {
              "click": function ($event) {
                return _vm.remove(index);
              }
            }
          }), _c('core-button', {
            attrs: {
              "color": _vm.color,
              "prepend-icon": "fa-plus"
            },
            on: {
              "click": function ($event) {
                return _vm.add(index);
              }
            }
          })];
        },
        proxy: true
      }], null, true)
    }, [_vm.doesConnectorIdExist(item.connectorId) ? [_c(VSelect, {
      attrs: {
        "items": _vm.connectors,
        "item-text": "name",
        "item-value": "id",
        "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.states.selectConnector'),
        "outlined": _vm.inpOutlined,
        "filled": _vm.inpFilled
      },
      scopedSlots: _vm._u([{
        key: "selection",
        fn: function (data) {
          return [_vm._v(_vm._s(data.item.name) + " (ID: " + _vm._s(data.item.id) + ")")];
        }
      }, {
        key: "item",
        fn: function (data) {
          return [_c(VListItemContent, [_c(VListItemTitle, [_vm._v("\n              " + _vm._s(data.item.name) + "\n            ")]), _c(VListItemSubtitle, [_vm._v("ID: " + _vm._s(data.item.id))])], 1)];
        }
      }], null, true),
      model: {
        value: item.connectorId,
        callback: function ($$v) {
          _vm.$set(item, "connectorId", $$v);
        },
        expression: "item.connectorId"
      }
    }), item.connectorId ? _c(_vm.getComponentForConnectorId(item.connectorId), {
      tag: "component",
      model: {
        value: item.config,
        callback: function ($$v) {
          _vm.$set(item, "config", $$v);
        },
        expression: "item.config"
      }
    }) : _vm._e()] : [_c('span', {
      staticClass: "text-bold"
    }, [_vm._v("\n        " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.states.outboundConnectorMissing', {
      connectorId: item.connectorId
    })) + "\n      ")]), _c('br'), _vm._v("\n      " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.states.outboundConnectorMissingConfig')) + ":\n      "), _c('pre', [_vm._v(_vm._s(item.config))])]], 2);
  }), 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };